import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/31_card_back_leopard/31_card_back_leopard"
 * Contains 1 texture(s)
 */
export class CardsBacks31CardBackLeopardAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/31_card_back_leopard/31_card_back_leopard';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '31_leopard.png'
    ] as const;
}
